/**
 * A request sent with failWhenOffline that could not reach the API: it was made while offline, or its connection
 * dropped and the API turned out unreachable. It is not held for the reconnect, so it is never sent later.
 */
export class ApiRequestOfflineError extends Error {
  constructor() {
    super('The API is unreachable, so the request was dropped instead of being sent after the reconnect')
    this.name = 'ApiRequestOfflineError'
  }
}
